
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30536',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30536",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54946",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8155",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11606",
  "I18n": "static-7.1642",
  "quartz": "static-1.7211",
  "quartz-config": "static-1.989",
  "quartz-core": "static-1.6430",
  "react-dlb": "static-1.81",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.6",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.833",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54933",
  "feedback-utils": "static-1.54937",
  "forms-embed-utils-lib": "static-1.4600",
  "forms-utils-lib": "static-1.12840",
  "foundations-assets": "static-1.5009",
  "foundations-components": "static-1.8202",
  "foundations-theming": "static-1.4569",
  "hub-http": "static-1.6357",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11913",
  "icons": "static-2.657",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4020",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16821",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5443",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.489",
  "tinymce-plugins": "static-1.57840",
  "transmute": "static-2.85",
  "ui-images": "static-2.1191",
  "UIComponents": "static-3.8552",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3501",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3488",
  "quartz-webpack": "static-1.3435",
  "foundations-theming-specialty": "static-1.2285",
  "property-description-translator": "static-1.3976",
  "HeadJS": "static-2.774",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3266",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4460",
  "jasmine-runner": "static-1.6592",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.849",
  "hubspotter-http": "static-1.4753",
  "mobile-manifest-mixins": "static-1.548",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.886",
  "quartz-head": "static-1.876",
  "quartz-i18n": "static-1.886",
  "quartz-routing": "static-1.641",
  "quartz-test": "static-1.886",
  "quartz-tracking": "static-1.590",
  "trellis-components": "static-1.2240",
  "ui-fonts": "static-1.868",
  "usage-tracker-container": "static-1.7476",
  "usage-tracker-core": "static-1.7336",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7382",
  "reference-resolvers": "static-1.8311",
  "sanitize-text": "static-1.8282",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10497",
  "sanitize": "static-1.4612",
  "outpost": "static-1.4304",
  "rpc-client-utils": "static-1.4792",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4471",
  "floating-ui": "static-1.58",
  "hs-story-utils": "static-1.9558",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.40",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2221",
  "bend-plugin-foundations-theming": "static-1.3052",
  "foundations-theming-base": "static-1.3554",
  "stylex": "static-1.35",
  "hs-locale-management": "static-1.183",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9290",
  "atom": "static-1.5211",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7970",
  "ContentUtils": "static-1.68759",
  "data-token-picker": "static-1.16648",
  "file-manager-components": "static-1.24020",
  "FileManagerCore": "static-1.39519",
  "FileManagerLib": "static-1.39660",
  "frontend-preferences-client": "static-1.8062",
  "hub-http-contrib": "static-1.3178",
  "interframe": "static-3.4894",
  "layout-dnd-components": "static-1.12712",
  "layout-dnd-utils": "static-1.11687",
  "property-translator": "static-1.5532",
  "react-codemirror": "static-1.10762",
  "react-colorpicker": "static-2.10342",
  "reference-resolvers-lite": "static-1.8231",
  "rich-text-lib": "static-1.20067",
  "tinymce-data": "static-1.40811",
  "tinymce-themes": "static-1.56696",
  "ui-addon-emoji-picker": "static-1.10020",
  "ui-addon-sales-email": "static-1.5345",
  "ui-brand-identity-lib": "static-1.15770",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10298",
  "hubspotter-http-shared-msw-handlers": "static-1.10296",
  "usage-tracker-session-replay": "static-1.5172",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1078",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.202",
  "chirp-fetch": "static-1.2023",
  "chatspot-core": "static-1.21949",
  "copilot-toolkit": "static-1.11480",
  "customer-data-objects-ui-components": "static-1.13164",
  "data-fetching-client": "static-1.9795",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4895",
  "ui-addon-video-player": "static-1.8840",
  "ui-coaching-tips": "static-1.28934",
  "usage-tracker": "static-1.7486",
  "cms-field-types": "static-1.4950",
  "content-icons-ui": "static-1.2267",
  "integrations-lib": "static-1.16579",
  "customer-data-objects": "static-1.7814",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1182",
  "apollo-link-hub-http": "static-2.4786",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4285",
  "ui-addon-iframeable": "static-1.9203",
  "video-components-external": "static-1.11729",
  "video-data-lib": "static-1.35387",
  "audio-components": "static-1.6126",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29550",
  "FileManagerImages": "static-1.37171",
  "foundations-components-legacy": "static-1.1227",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.527",
  "ui-universal-auth": "static-1.9141",
  "urlinator": "static-1.4670",
  "video-components": "static-1.13731",
  "video-embed": "static-1.36221",
  "ts-schema": "static-1.4184",
  "ContentData": "static-1.68834",
  "layout-data-lib": "static-1.10012",
  "react-dnd-compat": "static-1.4749",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1679",
  "external-options-client-types": "static-1.4229",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7029",
  "hs-promise-utils": "static-1.5729",
  "inbound-db-properties-service-client": "static-1.3948",
  "NamespacedHubStyle": "static-2.9156",
  "growth-onboarding-confetti": "static-1.3201",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11284",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5642",
  "magpie-types": "static-1.5102",
  "simple-logging-lib": "static-1.3184",
  "avatar-components": "static-1.2633",
  "customer-data-ui-utilities": "static-1.9959",
  "growth-onboarding-feedback-components": "static-1.6714",
  "flux-actions": "static-1.349",
  "hubspot-apollo-client": "static-1.5012",
  "integrations-error-boundary-lib": "static-1.13994",
  "integrations-tracking-lib": "static-1.5742",
  "laboratory-lib": "static-3.7287",
  "native-integrations-shared-strings": "static-1.7916",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10392",
  "unified-auth": "static-1.655",
  "breeze-engine-core": "static-1.460",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "navigation-messaging": "static-1.7657",
  "content-media-composition-data-lib": "static-1.12737",
  "content-media-compositions": "static-2.16744",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19164",
  "unified-auth-core-lib": "static-1.937",
  "social-insights-client-types": "static-1.22403",
  "advanced-menus-core": "static-1.15356",
  "advanced-menus-lib": "static-1.12264",
  "ExportDialog": "static-6.10514",
  "ui-memberships-settings-lib": "static-1.34409",
  "conditional-properties-service-client": "static-1.3900",
  "crm-pipelines-api-client-types": "static-1.4239",
  "fdsr-migration-layer": "static-1.148",
  "framework-builder-read-service-client": "static-1.4107",
  "framework-data-schema-quick-fetch": "static-1.6934",
  "inbound-db-meta-service-client": "static-1.3689",
  "multi-currency-client-types": "static-1.3793",
  "persist-promise": "static-1.3836",
  "foundations-components-test-utils": "static-1.5685",
  "reactive-lib": "static-1.861",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.471",
  "universal-page-editor-lib": "static-1.3146",
  "adobe-sign-auth-lib": "static-1.71",
  "ads-unified-auth-lib": "static-1.497",
  "google-sheets-integration-lib": "static-1.632",
  "microsoft-drive-integration-lib": "static-1.792",
  "surveymonkey-integration-lib": "static-1.90",
  "slack-ui-library": "static-1.10532",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3866",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15355",
  "simple-menus-lib": "static-1.16872",
  "crm-record-cards-service-types": "static-1.3687",
  "location-customization-utils-lib": "static-1.9643",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30536",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54946",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8155",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11606",
  "I18n": "/I18n/static-7.1642",
  "quartz": "/quartz/static-1.7211",
  "quartz-config": "/quartz-config/static-1.989",
  "quartz-core": "/quartz-core/static-1.6430",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.6",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.833",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54933",
  "feedback-utils": "/feedback-utils/static-1.54937",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4600",
  "forms-utils-lib": "/forms-utils-lib/static-1.12840",
  "foundations-assets": "/foundations-assets/static-1.5009",
  "foundations-components": "/foundations-components/static-1.8202",
  "foundations-theming": "/foundations-theming/static-1.4569",
  "hub-http": "/hub-http/static-1.6357",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11913",
  "icons": "/icons/static-2.657",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4020",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16821",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5443",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tinymce-plugins": "/tinymce-plugins/static-1.57840",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1191",
  "UIComponents": "/UIComponents/static-3.8552",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3501",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3488",
  "quartz-webpack": "/quartz-webpack/static-1.3435",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2285",
  "property-description-translator": "/property-description-translator/static-1.3976",
  "HeadJS": "/HeadJS/static-2.774",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3266",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4460",
  "jasmine-runner": "/jasmine-runner/static-1.6592",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.849",
  "hubspotter-http": "/hubspotter-http/static-1.4753",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.548",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.886",
  "quartz-head": "/quartz-head/static-1.876",
  "quartz-i18n": "/quartz-i18n/static-1.886",
  "quartz-routing": "/quartz-routing/static-1.641",
  "quartz-test": "/quartz-test/static-1.886",
  "quartz-tracking": "/quartz-tracking/static-1.590",
  "trellis-components": "/trellis-components/static-1.2240",
  "ui-fonts": "/ui-fonts/static-1.868",
  "usage-tracker-container": "/usage-tracker-container/static-1.7476",
  "usage-tracker-core": "/usage-tracker-core/static-1.7336",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7382",
  "reference-resolvers": "/reference-resolvers/static-1.8311",
  "sanitize-text": "/sanitize-text/static-1.8282",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10497",
  "sanitize": "/sanitize/static-1.4612",
  "outpost": "/outpost/static-1.4304",
  "rpc-client-utils": "/rpc-client-utils/static-1.4792",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4471",
  "floating-ui": "/floating-ui/static-1.58",
  "hs-story-utils": "/hs-story-utils/static-1.9558",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.40",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2221",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3052",
  "foundations-theming-base": "/foundations-theming-base/static-1.3554",
  "stylex": "/stylex/static-1.35",
  "hs-locale-management": "/hs-locale-management/static-1.183",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9290",
  "atom": "/atom/static-1.5211",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7970",
  "ContentUtils": "/ContentUtils/static-1.68759",
  "data-token-picker": "/data-token-picker/static-1.16648",
  "file-manager-components": "/file-manager-components/static-1.24020",
  "FileManagerCore": "/FileManagerCore/static-1.39519",
  "FileManagerLib": "/FileManagerLib/static-1.39660",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8062",
  "hub-http-contrib": "/hub-http-contrib/static-1.3178",
  "interframe": "/interframe/static-3.4894",
  "layout-dnd-components": "/layout-dnd-components/static-1.12712",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11687",
  "property-translator": "/property-translator/static-1.5532",
  "react-codemirror": "/react-codemirror/static-1.10762",
  "react-colorpicker": "/react-colorpicker/static-2.10342",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8231",
  "rich-text-lib": "/rich-text-lib/static-1.20067",
  "tinymce-data": "/tinymce-data/static-1.40811",
  "tinymce-themes": "/tinymce-themes/static-1.56696",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10020",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5345",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15770",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10298",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10296",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5172",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1078",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.202",
  "chirp-fetch": "/chirp-fetch/static-1.2023",
  "chatspot-core": "/chatspot-core/static-1.21949",
  "copilot-toolkit": "/copilot-toolkit/static-1.11480",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13164",
  "data-fetching-client": "/data-fetching-client/static-1.9795",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4895",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8840",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28934",
  "usage-tracker": "/usage-tracker/static-1.7486",
  "cms-field-types": "/cms-field-types/static-1.4950",
  "content-icons-ui": "/content-icons-ui/static-1.2267",
  "integrations-lib": "/integrations-lib/static-1.16579",
  "customer-data-objects": "/customer-data-objects/static-1.7814",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1182",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4786",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4285",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9203",
  "video-components-external": "/video-components-external/static-1.11729",
  "video-data-lib": "/video-data-lib/static-1.35387",
  "audio-components": "/audio-components/static-1.6126",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29550",
  "FileManagerImages": "/FileManagerImages/static-1.37171",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1227",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.527",
  "ui-universal-auth": "/ui-universal-auth/static-1.9141",
  "urlinator": "/urlinator/static-1.4670",
  "video-components": "/video-components/static-1.13731",
  "video-embed": "/video-embed/static-1.36221",
  "ts-schema": "/ts-schema/static-1.4184",
  "ContentData": "/ContentData/static-1.68834",
  "layout-data-lib": "/layout-data-lib/static-1.10012",
  "react-dnd-compat": "/react-dnd-compat/static-1.4749",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1679",
  "external-options-client-types": "/external-options-client-types/static-1.4229",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7029",
  "hs-promise-utils": "/hs-promise-utils/static-1.5729",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3948",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9156",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3201",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11284",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "magpie-types": "/magpie-types/static-1.5102",
  "simple-logging-lib": "/simple-logging-lib/static-1.3184",
  "avatar-components": "/avatar-components/static-1.2633",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9959",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6714",
  "flux-actions": "/flux-actions/static-1.349",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5012",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13994",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5742",
  "laboratory-lib": "/laboratory-lib/static-3.7287",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7916",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10392",
  "unified-auth": "/unified-auth/static-1.655",
  "breeze-engine-core": "/breeze-engine-core/static-1.460",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "navigation-messaging": "/navigation-messaging/static-1.7657",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12737",
  "content-media-compositions": "/content-media-compositions/static-2.16744",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19164",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.937",
  "social-insights-client-types": "/social-insights-client-types/static-1.22403",
  "advanced-menus-core": "/advanced-menus-core/static-1.15356",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12264",
  "ExportDialog": "/ExportDialog/static-6.10514",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34409",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3900",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4239",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.148",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4107",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6934",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3689",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3793",
  "persist-promise": "/persist-promise/static-1.3836",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5685",
  "reactive-lib": "/reactive-lib/static-1.861",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.471",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3146",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.71",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.497",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.632",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.792",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.90",
  "slack-ui-library": "/slack-ui-library/static-1.10532",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3866",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15355",
  "simple-menus-lib": "/simple-menus-lib/static-1.16872",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3687",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9643",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
